import restClient from "./BackendRestClient";

export function getActiveTermsAndConditions() {
    return restClient.get(["terms-and-conditions", "active"].join("/"))
        .then(res => res)
}